import actionTypes from '../constants/action-types';

const setScrollPosition = (position) => ({
  type: actionTypes.SET_SCROLL_POSITION,
  payload: {
    position,
  },
});

export default setScrollPosition;
